/*
 * @Author: cyerogy cyerogy@163.com
 * @Date: 2025-04-04 10:05:23
 * @LastEditors: cyerogy cyerogy@163.com
 * @LastEditTime: 2025-04-04 10:09:44
 * @FilePath: \projectorder\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vuex from 'vuex'
import getters from './getters'
import app from "./modules/app"
import user from './modules/user'

const store = new Vuex.Store({
  modules: {
    app,
    user
  },
  getters
})

export default store
